const abort = (message?: string): never => {
  throw new Error(message);
};

export default abort;
